import React from 'react';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';

function generateUserProfilePic(firstName, lastName = null) {
    if (!firstName) {
        return (
            <Avatar className='userProfilePic' sx={{ bgcolor: '#757575', color: '#fff' }}></Avatar>
        );
    }

    const label = `${firstName} ${lastName || ''}`.trim();
    const parts = label.split(/\s+/).filter(Boolean);
    let initials = '';
    if (parts[0]) initials += parts[0][0].toUpperCase();
    if (parts[1]) initials += parts[1][0].toUpperCase();
    if (initials.length === 0) initials = label.substring(0, 1).toUpperCase();
    initials = initials.substring(0, 2);

    const key = label;
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash * 31 + key.charCodeAt(i)) & 0xffffffff;
    }

    const palette = [
        { bg: '#e53935', color: '#fff' },
        { bg: '#303f9f', color: '#fff' },
        { bg: '#fdd835', color: '#000' },
        { bg: '#00796b', color: '#fff' }
    ];

    const sel = palette[Math.abs(hash) % palette.length];

    return (
        <Avatar className='userProfilePic' sx={{ bgcolor: sel.bg, color: sel.color }}>
            {initials}
        </Avatar>
    );
}

export default generateUserProfilePic;